import {
  Container,
  Title,
  Text,
  Card,
  Stack,
  ThemeIcon,
} from '@mantine/core';
import { Book } from 'react-feather';

export function CoachResourcesPage() {
  return (
    <Container size="lg" py="xl">
      <Title order={2} mb="xl">
        Resources
      </Title>

      <Card withBorder padding="xl" radius="md">
        <Stack align="center" gap="md" py="xl">
          <ThemeIcon size={64} radius="xl" variant="light" color="gray">
            <Book size={32} />
          </ThemeIcon>
          <Title order={3} ta="center" c="dimmed">
            Resources Coming Soon
          </Title>
          <Text size="sm" c="dimmed" ta="center" maw={400}>
            Coaching resources and materials will be available here. This will
            include guides, templates, and other materials to help you
            facilitate effective coaching sessions.
          </Text>
        </Stack>
      </Card>
    </Container>
  );
}

export default CoachResourcesPage;
